import classNames from "classnames/bind";
import styles from "./Filter.module.css";
import useFetchData from "../../../../hooks/useFetchData";
import { Button, SelectBox, SelectBoxItem } from "../../../../components";
import { Link } from "react-router-dom";
import { SearchBlack } from "../../../../components/Icons/Icons";

const cx = classNames.bind(styles);

function Filter({
  input,
  onChangeTextSearch,
  onChangeAddress,
  statusErr
}) {
  const province = useFetchData("province/get-info-province/", {
    nation_code: "VNM",
  });

  return (
    <>
      <div className={cx("filter")}>
        <div className={cx('fill-content')}>
          <div className={cx("search")}>
            <input
              value={input}
              onChange={onChangeTextSearch}
              className={cx("search-input")}
              placeholder="Tìm kiếm..."
              maxLength={155}
            />
            <span className={cx("icon-search")}>
              <SearchBlack />
            </span>
          </div>
        </div>
        <div>
          <Link
            to="/admin/companies/create"
            style={{ textDecoration: "none" }}
          >
            <Button
              className={cx("btn")}
              title="Tạo mới công ty"
              onClick={() => {
                return 0;
              }}
            />
          </Link>
        </div>
      </div>
    </>
  );
}

export default Filter;
